module.exports = __webpack_public_path__ + "img/i_speakerphone.dc3cf92a.svg";